var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 202,
    viewBox: "0 0 197 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7188 60.9467L21.0989 177.935L135.588 179.521L137.208 62.532L22.7188 60.9467ZM3.63732 60.6825C3.70893 55.5112 5.78797 50.5797 9.41708 46.9726C13.0462 43.3655 17.9281 41.3785 22.9888 41.4486L137.478 43.0338C142.539 43.1039 147.364 45.2254 150.891 48.9315C154.419 52.6377 156.361 57.625 156.289 62.7962L154.669 179.785C154.52 190.606 145.908 199.166 135.318 199.019L20.829 197.434C15.7682 197.364 10.9432 195.242 7.41537 191.536C3.88753 187.83 1.94583 182.842 2.01743 177.671L3.63732 60.6825ZM61.4218 22.4789L61.6918 2.98072L176.181 4.566C181.242 4.63607 186.067 6.75755 189.594 10.4637C193.122 14.1699 195.064 19.1571 194.992 24.3283L193.237 151.066L174.156 150.802L175.911 24.0641L61.4218 22.4789Z",
    fill: "#D4582A",
    stroke: "#D4582A",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.051f0c13575df99006b1b86d5f8ee708.svg";
export { ForwardRef as ReactComponent };